"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectToJSON = exports.ProjectFromJSONTyped = exports.ProjectFromJSON = exports.instanceOfProject = exports.ProjectStyleEnum = exports.ProjectProjectTypeKeyEnum = exports.ProjectAssigneeTypeEnum = void 0;
const IssueTypeDetails_1 = require("./IssueTypeDetails");
const ProjectArchivedBy_1 = require("./ProjectArchivedBy");
const ProjectAvatarUrls_1 = require("./ProjectAvatarUrls");
const ProjectComponent_1 = require("./ProjectComponent");
const ProjectDeletedBy_1 = require("./ProjectDeletedBy");
const ProjectInsight_1 = require("./ProjectInsight");
const ProjectIssueTypeHierarchy_1 = require("./ProjectIssueTypeHierarchy");
const ProjectLandingPageInfo_1 = require("./ProjectLandingPageInfo");
const ProjectLead_1 = require("./ProjectLead");
const ProjectPermissions_1 = require("./ProjectPermissions");
const ProjectProjectCategory_1 = require("./ProjectProjectCategory");
const Version_1 = require("./Version");
/**
 * @export
 */
exports.ProjectAssigneeTypeEnum = {
    ProjectLead: 'PROJECT_LEAD',
    Unassigned: 'UNASSIGNED'
};
/**
 * @export
 */
exports.ProjectProjectTypeKeyEnum = {
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business'
};
/**
 * @export
 */
exports.ProjectStyleEnum = {
    Classic: 'classic',
    NextGen: 'next-gen'
};
/**
 * Check if a given object implements the Project interface.
 */
function instanceOfProject(value) {
    return true;
}
exports.instanceOfProject = instanceOfProject;
function ProjectFromJSON(json) {
    return ProjectFromJSONTyped(json, false);
}
exports.ProjectFromJSON = ProjectFromJSON;
function ProjectFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'archived': json['archived'] == null ? undefined : json['archived'],
        'archivedBy': json['archivedBy'] == null ? undefined : (0, ProjectArchivedBy_1.ProjectArchivedByFromJSON)(json['archivedBy']),
        'archivedDate': json['archivedDate'] == null ? undefined : (new Date(json['archivedDate'])),
        'assigneeType': json['assigneeType'] == null ? undefined : json['assigneeType'],
        'avatarUrls': json['avatarUrls'] == null ? undefined : (0, ProjectAvatarUrls_1.ProjectAvatarUrlsFromJSON)(json['avatarUrls']),
        'components': json['components'] == null ? undefined : (json['components'].map(ProjectComponent_1.ProjectComponentFromJSON)),
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'deletedBy': json['deletedBy'] == null ? undefined : (0, ProjectDeletedBy_1.ProjectDeletedByFromJSON)(json['deletedBy']),
        'deletedDate': json['deletedDate'] == null ? undefined : (new Date(json['deletedDate'])),
        'description': json['description'] == null ? undefined : json['description'],
        'email': json['email'] == null ? undefined : json['email'],
        'expand': json['expand'] == null ? undefined : json['expand'],
        'favourite': json['favourite'] == null ? undefined : json['favourite'],
        'id': json['id'] == null ? undefined : json['id'],
        'insight': json['insight'] == null ? undefined : (0, ProjectInsight_1.ProjectInsightFromJSON)(json['insight']),
        'isPrivate': json['isPrivate'] == null ? undefined : json['isPrivate'],
        'issueTypeHierarchy': json['issueTypeHierarchy'] == null ? undefined : (0, ProjectIssueTypeHierarchy_1.ProjectIssueTypeHierarchyFromJSON)(json['issueTypeHierarchy']),
        'issueTypes': json['issueTypes'] == null ? undefined : (json['issueTypes'].map(IssueTypeDetails_1.IssueTypeDetailsFromJSON)),
        'key': json['key'] == null ? undefined : json['key'],
        'landingPageInfo': json['landingPageInfo'] == null ? undefined : (0, ProjectLandingPageInfo_1.ProjectLandingPageInfoFromJSON)(json['landingPageInfo']),
        'lead': json['lead'] == null ? undefined : (0, ProjectLead_1.ProjectLeadFromJSON)(json['lead']),
        'name': json['name'] == null ? undefined : json['name'],
        'permissions': json['permissions'] == null ? undefined : (0, ProjectPermissions_1.ProjectPermissionsFromJSON)(json['permissions']),
        'projectCategory': json['projectCategory'] == null ? undefined : (0, ProjectProjectCategory_1.ProjectProjectCategoryFromJSON)(json['projectCategory']),
        'projectTypeKey': json['projectTypeKey'] == null ? undefined : json['projectTypeKey'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'retentionTillDate': json['retentionTillDate'] == null ? undefined : (new Date(json['retentionTillDate'])),
        'roles': json['roles'] == null ? undefined : json['roles'],
        'self': json['self'] == null ? undefined : json['self'],
        'simplified': json['simplified'] == null ? undefined : json['simplified'],
        'style': json['style'] == null ? undefined : json['style'],
        'url': json['url'] == null ? undefined : json['url'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'versions': json['versions'] == null ? undefined : (json['versions'].map(Version_1.VersionFromJSON)),
    };
}
exports.ProjectFromJSONTyped = ProjectFromJSONTyped;
function ProjectToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'archivedBy': (0, ProjectArchivedBy_1.ProjectArchivedByToJSON)(value['archivedBy']),
        'avatarUrls': (0, ProjectAvatarUrls_1.ProjectAvatarUrlsToJSON)(value['avatarUrls']),
        'deletedBy': (0, ProjectDeletedBy_1.ProjectDeletedByToJSON)(value['deletedBy']),
        'email': value['email'],
        'favourite': value['favourite'],
        'id': value['id'],
        'insight': (0, ProjectInsight_1.ProjectInsightToJSON)(value['insight']),
        'issueTypeHierarchy': (0, ProjectIssueTypeHierarchy_1.ProjectIssueTypeHierarchyToJSON)(value['issueTypeHierarchy']),
        'landingPageInfo': (0, ProjectLandingPageInfo_1.ProjectLandingPageInfoToJSON)(value['landingPageInfo']),
        'lead': (0, ProjectLead_1.ProjectLeadToJSON)(value['lead']),
        'permissions': (0, ProjectPermissions_1.ProjectPermissionsToJSON)(value['permissions']),
        'projectCategory': (0, ProjectProjectCategory_1.ProjectProjectCategoryToJSON)(value['projectCategory']),
    };
}
exports.ProjectToJSON = ProjectToJSON;
//# sourceMappingURL=Project.js.map